import Pricing from '@app/pages/pricing';

const PricingContainer = () => {
  return <Pricing />;
};

export default PricingContainer;
